import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface AdminRouteProps {
  children: React.ReactNode;
  adminOnly?: boolean;
}

export default function AdminRoute({ children, adminOnly = false }: AdminRouteProps) {
  const { currentUser, isAdmin, isModerator, loading } = useAuth();

  if (loading) return null;

  const hasAccess = adminOnly ? isAdmin : isModerator;
  if (!currentUser || !hasAccess) return <Navigate to="/" replace />;

  return <>{children}</>;
}
